import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Faq.css';

const faqItems = [
  { 
    question: "What types of products or services can I promote with Adflyn?", 
    answer: "Adflyn supports promotion for a wide range of legal products and services, including e-commerce goods, software, digital services, and content sites. Our platform is designed to be highly versatile." 
  },
  { 
    question: "Which countries and regions does Adflyn support?", 
    answer: "We currently support targeted advertising campaigns in over 150 countries. Our geo-targeting tools allow you to precisely define your desired regions, from major markets to niche locations." 
  },
  { 
    question: "What platforms does Adflyn support?", 
    answer: "Adflyn integrates with all major social media platforms (Facebook, Instagram, LinkedIn, etc.) and various ad networks (Google Ads, etc.), providing a single dashboard for multi-channel campaigns." 
  },
  { 
    question: "Do I need my own Facebook business manager account to use Adflyn?", 
    answer: "No, you don't. While you can connect your existing account, Adflyn provides the option to manage campaigns through our proprietary business accounts for users who prefer a streamlined setup." 
  },
  { 
    question: "How is Adflyn different from other tools?", 
    answer: "Adflyn uses proprietary AI to optimize ad spend in real-time across multiple platforms simultaneously, a capability few competitors offer. We focus on conversion efficiency, not just impressions." 
  },
  { 
    question: "How does Adflyn handle ad spend?", 
    answer: "Your ad spend budget is managed directly through the Adflyn platform. Our system automatically allocates and optimizes spending across channels based on performance targets you set." 
  },
  { 
    question: "Can I cancel my Adflyn subscription at any time?", 
    answer: "Yes, all our subscription plans are monthly and can be canceled at any time without penalty. We believe in earning your business every month." 
  },
];

// ArrowIcon component moved outside for better performance
const ArrowIcon = () => (
  <svg 
    className="faq-icon" 
    viewBox="0 0 24 24" 
    strokeWidth="2" 
    stroke="currentColor" 
    fill="none" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {/* Horizontal line for the default state (like a plus icon) */}
    <path d="M18 12H6" />
    {/* Vertical line that is conditionally hidden or rotated */}
    <path d="M12 6v12" />
  </svg>
);

const FaqItem = ({ item, index, activeIndex, setActiveIndex }) => {
    const isActive = index === activeIndex;
    
    const toggleAccordion = () => {
        setActiveIndex(isActive ? null : index);
    };

  return (
    <button 
      className={`faq-item ${isActive ? 'active' : ''}`} 
      onClick={toggleAccordion}
      type="button"
      aria-expanded={isActive}
    >
      <div className="faq-question">
        <p>{item.question}</p>
        <ArrowIcon />
      </div>
      <div className="faq-answer-container">
        <p className="faq-answer">{item.answer}</p>
      </div>
    </button>
  );
};

FaqItem.propTypes = {
  item: PropTypes.shape({
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired
  }).isRequired,
  index: PropTypes.number.isRequired,
  activeIndex: PropTypes.number,
  setActiveIndex: PropTypes.func.isRequired
};


// --- Main FAQ Component ---
export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
      <section id="faq" className="faq-section">
        <div className="faq-content-wrapper">
          
          {/* Left Static Panel (Title/Call to Action) */}
          <div className="faq-left-panel">
            <h2 className="faq-title">Have other questions?</h2>
            <div className="faq-left-content">
            <p className="faq-help-text">We're here to help!</p>
            <button type="button" className="faq-contact-button" aria-label="Contact us">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </button>
            </div>
          </div>

          {/* Right Panel (FAQ Accordion List) */}
          <div className="faq-right-panel">
            {faqItems.map((item, index) => (
              <FaqItem 
                key={item.question}
                item={item}
                index={index}
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
              />
            ))}
          </div>
          
        </div>
      </section>
  );
}
